import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Icon, Radio, Segment, Label, Divider, Table, Popup, Accordion } from 'semantic-ui-react';
import _ from 'lodash';
import axios from 'axios';
import shortid from 'shortid';
import { connect } from 'react-redux';
import countries from '../../utils/helpers/countries';
import InfluencerCardPreview from '../influencer-card-preview';
import InfluencerContextBar from '../influencer-context-bar';

import TargetLink from '../../components/target-link';
import TagsSelector from '../../components/tags-selector';
import BusinessUnitsSelector from '../../components/business-units-selector';
import ThemeSelector from '../../themes/theme-selector';
import hasRESTClient from '../../hocs/has-rest-client';
import hasOrgansation from '../../hocs/has-organisation';
import hasUserInfo from '../../hocs/has-user-info';
import ValidatedEmailField from '../../components/validated-email-field';
import NetworkHandleInput from '../../components/network-handle-input';
import LimitsExceededModal from '../../components/limits-exceeded-modal';
import DuplicatedInfluencerError from '../../components/duplicated-influencer-error';
import sendLimitsExceededNotification from '../../utils/send-limits-exceeded-notifcation';
import { ageOptions, genderOptions, ethnicityOptions } from './influencer-form-options';
import {
  FacebookIcon,
  TiktokIcon,
  TwitterIcon,
  InstagramIcon,
  YoutubeIcon,
  TwitchIcon,
  TelegramIcon,
} from '../dyzio-icons';

import { channel } from 'redux-saga';

const TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
const TELEGRAM_CHANNEL_API = `${TELEGRAM_API_BASE_URL}/telegram/channel`;
const TELEGRAM_BASE_URL = 'https://t.me/';

const HANDLE_PROMPT = 'Enter the influencers handle, or copy-paste their profile\'s url';
const INITIAL_DEMOGRAPHICS_LIMIT = 25;

const blockDisplayStyle = {
  display: 'block',
  width: 100,
};

const middleVertAlign = {
  'vertical-align': 'middle',
};

const blockDisplayFullWidthStyle = {
  display: 'block',
  width: '100%',
};

const grey75TextStyle = {
  color: '#939393',
  'font-size': '0.75rem',
};

const instagramErrorStyle = {
  color: '#20c49e',
  opacity: 1,
};

const buttonStyles = {
  width: '150px',
};

const businessUnitsHelpUrl = 'https://help.dyzio.co/en/articles/5137000-adding-business-units-or-brands';
const tagsHelpUrl = 'https://help.dyzio.co/en/articles/4865489-global-tag-manager';
const youtubeHelpUrl = 'http://help.dyzio.co/en/articles/5543117-adding-an-influencer-s-youtube-channel';

const SocialNetworkIcon = ({
  icon, isBusinessAccount, isPrivateAccount,
}) => {
  if (isBusinessAccount || isPrivateAccount) {
    return (<Popup
      trigger={
        <Icon.Group size="large">
          <Icon name="instagram" color="pink" />
          <Icon corner name={isBusinessAccount ? 'briefcase' : 'lock'} color="pink" />
        </Icon.Group>
      }
      content={isBusinessAccount ? 'Business Account' : 'This account is private'}
    />);
  }

  return icon;
};

const SocialChannelInfo = props => {
  const { username, fullName, icon, isVerified, isBusinessAccount, isPrivateAccount } = props;
  if (!username) return null;
  const socialIconProps = { icon, isBusinessAccount, isPrivateAccount };
  return (
    <Table.Row>
      <Table.Cell>
        <SocialNetworkIcon {...socialIconProps} />
      </Table.Cell>
      <Table.Cell>
        { username || '-' }
      </Table.Cell>
      <Table.Cell>
        { fullName || '-' }
      </Table.Cell>
      <Table.Cell>
        <Icon name="check circle" color={isVerified ? 'blue' : 'gray'} />
      </Table.Cell>
    </Table.Row>
  );
};

const searchTelegramChannel = async telegram => {
  console.log('searchTelegramChannel');
  const lowerValue = _.toLower(telegram);
  const channelUrl = _.replace(lowerValue, TELEGRAM_BASE_URL, '');
  const searchUrl = `${TELEGRAM_CHANNEL_API}/${channelUrl}`;
  console.log(searchUrl);

  const response = await axios.get(searchUrl);
  const { data: { data } } = response;
  console.log(data);
  return data;
};

const getTelegramAddChannelUrl = () => {
  const url = `${TELEGRAM_API_BASE_URL}/influencer/telegram/channels`;
  return url;
};

const addTelegramChannel = async (channelData, userInfo) => {
  console.log('addTelegramChannel');

  const addChannelUrl = getTelegramAddChannelUrl();
  const payload = {
    channelData,
    userInfo,
  };

  const response = await axios.post(addChannelUrl, payload).then(r => r.data.data);
  console.log(response);
  const { data } = response;
  return _.get(data, 'id');
};

SocialChannelInfo.defaultProps = {
  isBusinessAccount: false,
};

class InfluencerForm extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();

    this.state = {
      name: '',
      email: '',
      contactNumber: '',
      thumbnail: '',
      primarySocialHandle: '',
      facebook: '',
      facebookPageName: '',
      facebookUserName: '',
      facebookCount: '',
      facebookLoading: false,
      facebookError: false,
      instagram: '',
      instagramUsername: '',
      instagramId: '',
      instagramFullName: '',
      instagramCount: '',
      instagramLoading: false,
      instagramError: false,
      instagramErrorCode: '',
      instagramBusinessAccount: false,
      instagramProfessionalAccount: false,
      instagramCategory: '',
      isFacebookPersonalPage: false,
      instagramPrivate: false,
      twitter: '',
      twitterCount: '',
      twitterLoading: false,
      twitterError: false,
      twitch: '',
      twitchCount: '',
      twitchLoading: false,
      twitchError: false,
      tiktok: '',
      tiktokCount: '',
      tiktokUserId: '',
      tiktokName: '',
      tiktokLoading: false,
      tiktokError: false,
      tiktokVerified: false,
      tiktokThumbnail: '',
      tiktokProfileData: {},
      youtube: '',
      twitchUserId: '',
      youtubeCount: '',
      youtubeErorr: false,
      youtubeLoading: false,
      youtubeChannelTitle: '',
      primarySocialHandleYoutube: false,
      otherChannels: [],
      addChannel: false,
      newChannelName: '',
      newChannelHandle: '',
      handles: [],
      agent: false,
      agentName: '',
      agentEmail: '',
      agentContactNumber: '',
      associated: true,
      contentTags: [],
      brandTags: [],
      addressLine1: '',
      city: '',
      region: '',
      postalCode: '',
      country: '',
      description: '',
      timeout: null,
      web: '',
      snapchat: '',
      linkedin: '',
      tags: [],
      businessUnits: [],
      telegramUser: '',
      telegramFound: '',
      telegramObj: {},
      telegramLoading: false,
      telegramError: false,

      facebookVerified: false,
      twitterVerified: false,
      youtubeVerified: false,
      instagramVerified: false,

      isEmailFieldValid: true,

      duplicateInfluencerHandle: '',
      duplicateInfluencerPlatform: '',
      duplicateInfluencerLinkId: '',

      activeIndex: -1,
    };
  }

  onSubmit = async e => {
    e.preventDefault();

    const { jsonAPIClient, user, userInfo } = this.props;

    const {
      name,
      email,
      contactNumber,
      thumbnail,
      primarySocialHandle,
      facebook,
      facebookCount,
      instagram,
      instagramId,
      instagramCount,
      twitter,
      twitterCount,
      youtube,
      youtubeCount,
      youtubeChannelTitle,
      youtubeData,
      instagramBusinessAccount,
      instagramPrivate,
      instagramProfessionalAccount,
      instagramCategory,
      isFacebookPersonalPage,
      otherChannels,
      agentName,
      agentEmail,
      agentContactNumber,
      associated,
      contentTags,
      brandTags,
      addressLine1,
      city,
      region,
      postalCode,
      country,
      description,
      web,
      snapchat,
      linkedin,
      pinterest,
      twitch,
      twitchCount,
      twitchUserId,

      tiktok,
      tiktokCount,
      tiktokThumbnail,
      tiktokProfileData,

      telegramUser,
      telegramObj,
      telegramFound,

      tags,
      businessUnits,
      ageGroup,
      gender,
      ethnicity,
    } = this.state;

    const totalSocialReach =
    (parseFloat(facebookCount) || 0) +
    (parseFloat(instagramCount) || 0) +
    (parseFloat(twitterCount) || 0) +
    (parseFloat(twitchCount) || 0) +
    (parseFloat(tiktokCount) || 0) +
    (parseFloat(youtubeCount) || 0);

    const trimmedEmail = _.trim(email);

    const data = {
      name,
      email: trimmedEmail,
      contactNumber,
      thumbnail,
      primarySocialHandle,
      facebook,
      facebookCount,
      instagram,
      instagramCount,
      twitter,
      twitterCount,
      youtube,
      youtubeCount,
      youtubeChannelTitle,
      youtubeData,
      otherChannels,
      totalSocialReach,
      agentName,
      agentEmail,
      agentContactNumber,
      addressLine1,
      city,
      region,
      postalCode,
      country,
      pinterest,
      web,
      snapchat,
      linkedin,
      instagramBusinessAccount,
      instagramProfessionalAccount,
      instagramCategory,
      instagramPrivate,
      isFacebookPersonalPage,
      twitch,
      twitchCount,
      twitchUserId,
      tiktok,
      tiktokCount,
      tiktokThumbnail,
      tiktokProfileData,
      telegramUser,
      telegramObj,
      telegramFound,
      ageBracket: ageGroup,
      gender,
      ethnicity,
    };

    const details = {
      email: trimmedEmail,
      associated,
      contentTags: _.split(contentTags, ','),
      brandTags: _.split(brandTags, ','),
      description,
    };

    const fields = [
      'email',
      'contactNumber',
      'instagramBusinessAccount',
      'instagramProfessionalAccount',
      'instagramCategory',
      'instagramPrivate',
      'thumbnail',
      'facebook',
      'instagram',
      'pinterest',
      'twitter',
      'youtube',
      'agentName',
      'agentContactNumber',
      'addressLine1',
      'city',
      'region',
      'postalCode',
      'country',
      'youtubeChannelTitle',
      'twitch',
      'tiktok',
      'tiktokThumbnail',
      'tiktokProfileData',
      'snapchat',
      'linkedin',
      'web',
      'ageBracket',
      'gender',
      'ethnicity',
    ];

    // create the influencer
    const influencer = jsonAPIClient.create('influencer');
    influencer.set('name', data.name);
    influencer.set('primarySocialHandle', data.primarySocialHandle);
    influencer.set('facebookCount', (data.facebookCount || 0));
    influencer.set('instagramCount', (data.instagramCount || 0));
    influencer.set('twitterCount', (data.twitterCount || 0));
    influencer.set('youtubeCount', (data.youtubeCount || 0));
    influencer.set('twitchCount', (data.twitchCount || 0));
    influencer.set('tiktokCount', (data.tiktokCount || 0));
    influencer.set('otherChannels', data.otherChannels);
    influencer.set('totalSocialReach', data.totalSocialReach);
    influencer.set('isFacebookPersonalPage', data.isFacebookPersonalPage || false);

    const youtubeChannelId = _.get(data, 'youtubeData.id', null);
    if (youtubeChannelId) {
      influencer.set('youtubeChannelId', youtubeChannelId);
    }

    if (data.tiktokProfileData) {
      influencer.set('tiktokId', data.tiktokProfileData.id);
    }

    if (telegramFound && telegramUser) {
      // const channelData = await searchTelegramChannel(telegramUser);
      const channelData = data.telegramObj;

      console.log('channelData', channelData);

      const dyizTelegramUserId = await addTelegramChannel(channelData, userInfo);
      console.log('dyizTelegramUserId', dyizTelegramUserId);

      const telegramUserObj = {
        type: 'telegramChannels',
        id: dyizTelegramUserId,
      };
      influencer.set('telegramUser', telegramUserObj);
    }


    if (twitchUserId) {
      influencer.set('twitchId', _.toNumber(twitchUserId));
    }
    if (instagramId) {
      influencer.set('instagramId', instagramId);
    }

    _.forEach(fields, field => {
      const value = data[field];
      if (!_.isNil(value) && !_.isEqual(value, '')) {
        influencer.set(field, value);
      }
    });

    influencer.sync()
      .then(influencerResponse => {
        const flatInfluencer = influencerResponse.toJSON();
        const influencerDetails = jsonAPIClient.create('influencerDetails');
        influencerDetails.set('associated', details.associated);
        influencerDetails.set('contentTags', details.contentTags);
        influencerDetails.set('brandTags', details.brandTags);
        influencerDetails.set('description', details.description);

        if (!_.isEmpty(tags)) {
          const influencerTags = _.map(tags, tag => ({
            id: tag,
            type: 'tags',
          }));
          influencerDetails.set('tags', influencerTags);
        }

        if (!_.isEmpty(businessUnits)) {
          const influencerbBusinessUnits = _.map(businessUnits, businessUnit => ({
            id: businessUnit,
            type: 'businessUnits',
          }));
          influencerDetails.set('businessUnits', influencerbBusinessUnits);
        }

        if (details.email) {
          influencerDetails.set('email', details.email);
        }

        influencerDetails.sync().then(async detailsResponse => {
          const influencerLink = jsonAPIClient.create('influencerLink');
          influencerLink.set('organisation', { type: 'organisations', id: user.organisation.id });
          influencerLink.set('influencer', { type: 'influencer', id: flatInfluencer.id });
          influencerLink.set('influencerDetails', { type: 'influencerDetails', id: detailsResponse.toJSON().id });
          influencerLink.sync();

          const instagramHandleInput = _.get(data, 'instagram');
          console.log('adding instagram', instagramHandleInput);
          console.log('instagram id', instagramId);
          if (instagramHandleInput &&
              this.state.numberOfProcessedInfluencers < INITIAL_DEMOGRAPHICS_LIMIT &&
              this.state.numberOfProcessedInfluencers !== -1) {
            console.log('sending demographics', instagramHandleInput);
            await this.sendForDemographics(instagramHandleInput, flatInfluencer.id, instagramId);
          }

          const cachebuster = shortid.generate();
          this.context.router.push(`/influencers?cb=${cachebuster}`);
        });
      });
  };

  leftButtonCallback = () => this.context.router.push('/dashboard');

  rightButtonCallback = () => this.context.router.push('/influencer/add');

  loadDemographicsStats = () => {
    const { buildRESTClient, userInfo: { organisationId } } = this.props;
    const influencerFilterApiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_INFLUENCER_FILTER_API,
    });
    // const demographicsStatsURl = '/organisation/15e0ffdb-bd62-4eaf-b8ba-fb242ebc6fd6/demographics-stats';
    const demographicsStatsURl = `/organisation/${organisationId}/demographics-stats`;
    influencerFilterApiClient.get(demographicsStatsURl).then(response => {
      const { numberOfInfluencers, numberOfProcessedInfluencers } = response.data;
      console.log('Demographics Stats fetched',
        `${numberOfProcessedInfluencers}/${numberOfInfluencers}`);
      if (!numberOfProcessedInfluencers && numberOfProcessedInfluencers !== 0) {
        this.setState({
          numberOfInfluencers: -1,
          numberOfProcessedInfluencers: -1,
        });
      } else {
        this.setState({
          numberOfInfluencers,
          numberOfProcessedInfluencers,
        });
      }
      console.log('Demographics Stats set',
        `${this.state.numberOfProcessedInfluencers}/${this.state.numberOfInfluencers}`);
    }).catch(err => {
      console.log('err', err);
      this.setState({
        numberOfInfluencers: 0,
        numberOfProcessedInfluencers: 0,
      });
    });
    return null;
  }

  sendForDemographics = async (instagramUsername, id, instagramId) => {
    console.log(instagramUsername, id);
    const payload = {
      data: {
        forceScan: true,
        influencer: {
          username: instagramUsername,
          instagramId,
          id,
        },
      },
    };
    const { buildRESTClient } = this.props;
    const demographicsAPI = buildRESTClient({
      baseURL: process.env.REACT_APP_DEMOGRAPHICS_SERVICE_API,
    });
    await demographicsAPI.post('/production/influencers/process', payload).then(response => {
      console.log(response.data);
    }).catch(err => {
      console.log('err', err);
    });
  };

  getInstagramFollowerCount = async (id, followerCount) => {
    console.log(`fetching follower count for instagram ID - ${id}`);
    console.log(process.env.REACT_APP_GET_INSTAGRAM_FOLLOWER_COUNT);
    const { buildRESTClient } = this.props;
    const instagramFollowerCountApiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_GET_INSTAGRAM_FOLLOWER_COUNT,
    });
    instagramFollowerCountApiClient
      .get(id)
      .then(response => {
        console.log(response);
        const { data } = response;
        const count = data.data.followerCount;
        console.log('IG Follower Count', count);
        this.setState({
          instagramCount: count,
        });
      }).catch(err => {
        console.log('err', err);
        this.setState({
          instagramCount: followerCount,
        });
      });
  };

  revertDuplicateHandleChannelError = channel => {
    const { duplicateInfluencerPlatform } = this.state;
    if (_.eq(channel, duplicateInfluencerPlatform)) {
      this.setState({
        duplicateInfluencerHandle: null,
        duplicateInfluencerPlatform: null,
        duplicateInfluencerLinkId: null,
      });
    }
  }

  getChannelData = async (channel, handle) => {
    const count = `${channel}Count`;
    const loading = `${channel}Loading`;
    const error = `${channel}Error`;
    const thumbnail = `${channel}Thumbnail`;
    this.revertDuplicateHandleChannelError(channel);

    if (channel === 'instagram') {
      this.setState({
        instagramError: false,
        instagramErrorCode: '',
      });
    }

    const options = {
      data: {
        platform: channel,
        name: _.trimStart(handle, '@'),
      },
    };

    this.setState({
      [loading]: true,
    });

    if (handle.length === 0) {
      const details = {
        [loading]: false,
        [count]: 0,
        [error]: false,
        [thumbnail]: '',
      };
      switch (channel) {
      case 'facebook':
        details.facebookPageName = null;
        details.facebookUserName = null;
        details.facebookVerified = false;
        break;
      case 'instagram':
        details.instagramFullName = null;
        details.instagramUserName = null;
        details.instagramVerified = false;
        break;
      case 'twitter':
        details.twitterPageName = null;
        details.twitterUserName = null;
        details.twitterVerified = false;
        break;
      case 'youtube':
        details.youtubeChannelTitle = null;
        details.youtubeChannelUserName = null;
        details.youtubeVerified = false;
        details.youtubeData = null;
        break;
      case 'twitch':
        details.name = null;
        details.twitchChannelTitle = null;
        details.twitchUserId = null;
        break;
      case 'tiktok':
        details.tiktokName = null;
        details.tiktokVerified = false;
        break;
      case 'telegram':
        details.telegramUser = null;
        details.telegramFound = 0;
        details.telegramObj = {};
        break;
      default: break;
      }
      return this.setState({
        ...details,
      });
    }

    const { buildRESTClient, userInfo: { organisationId } } = this.props;
    const influencerFilterApiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_INFLUENCER_FILTER_API,
    });

    const duplicateCheck = await influencerFilterApiClient.get('influencer/influencer-duplicate-check', {
      params: {
        organisationId,
        platform: channel,
        handle,
      },
    }).catch(err => console.error(err));

    const exists = _.get(duplicateCheck, 'data.data.exists', false);
    const dupID = _.head(_.get(duplicateCheck, 'data.data.ids', []));

    if (exists) {
      this.setState({
        duplicateInfluencerHandle: handle,
        duplicateInfluencerPlatform: channel,
        duplicateInfluencerLinkId: dupID,
        [loading]: false,
        [error]: true,
        [channel]: null,
      });
      return null;
    }

    return axios
      .post(process.env.REACT_APP_GET_INFLUENCER_DATA_URL, options)
      .then(response => {
        if (_.isEqual(channel, 'instagram') && response.data.statusCode === 500) {
          this.setState({
            instagramErrorCode: 'NO_MATCH',
          });
        }

        this.setState({
          [loading]: false,
          [count]: response.data.body.data.followerCount,
          [error]: false,
          [thumbnail]: response.data.body.data.thumbnail,
        });

        const country = response.data.body.data.location;

        const details = {};
        switch (channel) {
        case 'facebook':
          details.name = response.data.body.data.pagename;
          details.facebookPageName = response.data.body.data.pagename;
          details.facebookUserName = response.data.body.data.username;
          details.facebookVerified = response.data.body.data.verified;
          details.isFacebookPersonalPage = response.data.body.data.isPersonalPage;
          this.revertDuplicateHandleChannelError('facebook');
          break;
        case 'instagram':
          details.name = response.data.body.data.full_name;
          details.instagramFullName = response.data.body.data.full_name;
          details.instagramUserName = response.data.body.data.username;
          details.instagramVerified = response.data.body.data.isVerified;
          details.instagramBusinessAccount = response.data.body.data.instagramBusinessAccount;
          details.instagramPrivate = response.data.body.data.isPrivate;
          details.instagramProfessionalAccount = response.data.body.data.instagramProfessionalAccount;
          if (response.data.body.data.instagramCategory) {
            details.instagramCategory = response.data.body.data.instagramCategory;
          }
          details.instagramId = response.data.body.data.id;
          this.getInstagramFollowerCount(details.instagramId, response.data.body.data.followerCount);
          this.revertDuplicateHandleChannelError('instagram');
          break;
        case 'twitter':
          details.twitterPageName = response.data.body.data.name;
          details.name = response.data.body.data.name;
          details.twitterUserName = response.data.body.data.screen_name;
          details.twitterVerified = response.data.body.data.verified;
          this.revertDuplicateHandleChannelError('twitter');
          break;
        case 'youtube':
          details.youtubeChannelTitle = response.data.body.data.channelTitle;
          details.name = response.data.body.data.channelTitle;
          details.youtubeChannelUserName = response.data.body.data.username;
          details.youtubeVerified = response.data.body.data.verified;
          details.youtubeData = response.data.body.data;
          this.revertDuplicateHandleChannelError('youtube');
          break;
        case 'twitch':
          details.name = response.data.body.data.name;
          details.twitchChannelTitle = response.data.body.data.name;
          details.twitchUserId = response.data.body.data.userId;
          this.revertDuplicateHandleChannelError('twitch');
          break;
        case 'tiktok':
          details.tiktokName = response.data.body.data.name;
          details.tiktokVerified = response.data.body.data.verified;
          details.tiktokThumbnail = response.data.body.data.thumbnail;
          details.tiktokProfileData = response.data.body.data;
          this.revertDuplicateHandleChannelError('tiktok');
          break;
        default: break;
        }

        if (channel === 'telegram') {
          const telegramData = response.data.body.data;
          const { typeInfo: { type }, ogResponse } = telegramData;
          console.log('get telegram user data');
          console.log(telegramData);
          console.log(type === 'USER');

          if (type !== 'USER') {
            details.telegramError = true;
          } else {
            details.telegramUser = handle;
            details.telegramObj = response.data.body.data;
            details.telegramFound = 1;
            const telegramThumbnail = _.get(ogResponse, 'openGraph.image.url');
            details.name = _.get(ogResponse, 'openGraph.title');
            if (telegramThumbnail) {
              details.thumbnail = telegramThumbnail;
            }
          }
          // this.revertDuplicateHandleChannelError('telegram');
        }

        const newState = _.assign({
          thumbnail: response.data.body.data.thumbnail,
          country,
          shouldRenderSocialHandlesBlock: true,
        }, details);

        this.setState(newState);

        const { handles, youtubeChannelTitle } = this.state;
        const o = {
          key: channel,
          value: channel,
          text: channel === 'youtube' ? `${youtubeChannelTitle} (${channel})` : `${handle} (${channel})`,
        };
        const a = handles.filter(obj => obj.key !== channel);
        a.push(o);
        this.setState({ handles: a });
      })
      .catch(e => {
        // if instagramErrorCode not set to NO_MATCH then it is a genuine error
        console.log(e);
        const { instagramErrorCode } = this.state;
        if (!instagramErrorCode) {
          if (_.isEqual(channel, 'instagram')) {
            this.setState({
              instagramErrorCode: 'ERROR',
            });
          }
        }
        this.setState({ [loading]: false, [error]: true });
      });
  }

  componentDidMount = () => {
    const { campaignAPIClient, restClient, userInfo: { organisationId, name, id }, organisation } = this.props;
    this.setState({
      isLoadingTotals: true,
    });

    const requests = [
      campaignAPIClient.get(`/summary/influencers?organisationId=${organisationId}`),
    ];

    this.loadDemographicsStats();

    return Promise.all(requests).then(([{ data: { data: { totalInfluencers } } }]) => this.setState({
      totalInfluencers,
      isLoadingTotals: false,
    }, this.checkLimitsNotification));
  }

  componentWillReceiveProps = (newProps, oldProps) => {
    if (newProps.organisation
      && newProps.userInfo
      && _.get(newProps, 'organisation.name') !== _.get(oldProps, 'organisation.name')
    ) {
      this.checkLimitsNotification();
    }
  }

  checkLimitsNotification = () => {
    const { restClient, userInfo: { organisationId, name, userId }, organisation } = this.props;
    const { totalInfluencers } = this.state;
    if (!totalInfluencers || !organisation) return;
    if (totalInfluencers < organisation.licenseInfluencerLimit) return;
    sendLimitsExceededNotification(restClient, {
      data: {
        name: `${name} `,
        organisationId,
        userId,
        organisationName: `${organisation.name} `,
        assetType: 'influencers',
        licenseSubscriptionType: organisation.licenseSubscriptionType,
        url: window.location.href,
      },
    });
  }

  getPrimaryHandleOptions = () => {
    const {
      facebook,
      facebookCount,
      instagram,
      instagramCount,
      twitter,
      twitterCount,
      youtube,
      youtubeCount,
      telegramUser,
      telegramFound,
    } = this.state;
    const optionsArray = [];
    if (facebookCount) {
      const option = {
        key: 'a',
        text: facebook,
        value: 'facebook',
      };
      optionsArray.push(option);
    }

    if (instagramCount) {
      const option = {
        key: 'b',
        text: instagram,
        value: 'instagram',
      };
      optionsArray.push(option);
    }

    if (twitterCount) {
      const option = {
        key: 'c',
        text: twitter,
        value: 'twitter',
      };
      optionsArray.push(option);
    }

    if (youtubeCount) {
      const option = {
        key: 'd',
        text: youtube,
        value: 'youtube',
      };
      optionsArray.push(option);
    }

    if (telegramFound) {
      const option = {
        key: 'e',
        text: telegramUser,
        value: 'telegram',
      };
      optionsArray.push(option);
    }

    return optionsArray;
  };

  handleChange = (e, v) => {
    this.setState({
      [v.name]: v.value,
    });
  };

  handlePrimarySocialHandleChange = (e, v) => {
    const {
      facebook,
      facebookThumbnail,
      facebookPageName,
      instagram,
      instagramFullName,
      instagramThumbnail,
      twitter,
      twitterPageName,
      twitterThumbnail,
      youtube,
      youtubeChannelTitle,
      youtubeThumbnail,
      twitch,
      twitchThumbnail,

      tiktok,
      tiktokName,
      tiktokThumbnail,
      telegramUser,
      telegramObj,
    } = this.state;

    if (v.value === 'telegram') {
      this.setState({
        thumbnail: _.get(telegramObj, 'ogResponse.openGraph.image.url'),
        name: _.get(telegramObj, 'ogResponse.openGraph.title'),
        primarySocialHandle: telegramUser,
        primarySocialHandleYoutube: false,
      });
    }

    if (v.value === 'tiktok') {
      this.setState({
        thumbnail: tiktokThumbnail,
        name: tiktokName,
        primarySocialHandle: tiktok,
        primarySocialHandleYoutube: false,
      });
    }

    if (v.value === 'twitch') {
      this.setState({
        thumbnail: twitchThumbnail,
        primarySocialHandle: twitch,
        primarySocialHandleYoutube: false,
      });
    }

    if (v.value === 'facebook') {
      this.setState({
        thumbnail: facebookThumbnail,
        name: facebookPageName,
        primarySocialHandle: facebook,
        primarySocialHandleYoutube: false,
      });
    }
    if (v.value === 'instagram') {
      this.setState({
        thumbnail: instagramThumbnail,
        name: instagramFullName,
        primarySocialHandle: instagram,
        primarySocialHandleYoutube: false,
      });
    }
    if (v.value === 'twitter') {
      this.setState({
        thumbnail: twitterThumbnail,
        name: twitterPageName,
        primarySocialHandle: twitter,
        primarySocialHandleYoutube: false,
      });
    }
    if (v.value === 'youtube') {
      this.setState({
        thumbnail: youtubeThumbnail,
        name: youtubeChannelTitle,
        primarySocialHandle: youtube,
        primarySocialHandleYoutube: true,
      });
    }
  }

  handleTagChange = (e, v) => {
    const { name, value } = v;
    this.setState({
      [name]: value,
    });
  };

  onInfluencerEmailStateChanged = (isValid, value) => {
    this.setState({
      isEmailFieldValid: isValid,
      email: value,
    });
  }

  handleBasicSocialChange = (e, v) => {
    const { name, value } = v;
    this.setState({
      [name]: _.replace(value, /\s/g, ''),
    });
  };

  handleSocialChange = (e, v) => {
    const value = _.replace(_.get(v, 'value'), /\s/g, '');
    this.setState({ [v.name]: value });
    let timeout = this.state.timeout;
    clearTimeout(timeout);
    timeout = setTimeout(() => this.getChannelData(v.name, value), 500);
    this.setState({ timeout });
  };

  retryInstagramHandle = () => {
    const { instagram } = this.state;
    console.log('retry search for instagram handle', instagram);
    this.getChannelData('instagram', instagram);
  };

  handleChannelAdd = () => {
    const { newChannelName, newChannelHandle, otherChannels } = this.state;
    const obj = {
      name: newChannelName,
      handle: newChannelHandle,
    };
    otherChannels.push(obj);
    this.setState({ otherChannels, newChannelName: '', newChannelHandle: '' });
  }

  handleChannelRemove = (name, handle) => {
    const { otherChannels } = this.state;
    const a = otherChannels.filter(o => o.name !== name);
    this.setState({ otherChannels: a });
  }

  findIcon = (c, e) => {
    if (e) {
      return 'close';
    }
    return c > 0 ? 'check' : 'search';
  }

  onTagSelected = tagId => {
    const { tags: selectedTags } = this.state;
    const tags = _.concat(selectedTags, [tagId]);
    this.setState({
      tags,
    });
  }

  onUnselected = tagId => {
    const { tags: selectedTags } = this.state;
    const tags = _.reject(selectedTags, tag => tag === tagId);
    this.setState({
      tags,
    });
  }

  onBusinessUnitSelected = businessUnitId => {
    const { businessUnits: selectedBusinessUnits } = this.state;
    const businessUnits = _.concat(selectedBusinessUnits, [businessUnitId]);
    this.setState({
      businessUnits,
    });
  }

  onUnselectedBusinessUnit = businessUnitId => {
    const { businessUnits: selectedBusinessUnits } = this.state;
    const businessUnits = _.reject(selectedBusinessUnits, businessUnit => businessUnit === businessUnitId);
    this.setState({
      businessUnits,
    });
  }

  toggleOptionalInfo = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  render() {
    const {
      organisation,
      organisationLoading,
    } = this.props;

    const {
      name,
      email,
      contactNumber,
      thumbnail,
      country,
      primarySocialHandle,
      facebook,
      facebookCount,
      facebookLoading,
      facebookError,
      instagram,
      instagramCount,
      instagramLoading,
      instagramError,
      instagramErrorCode,
      twitter,
      twitterCount,
      twitterLoading,
      twitterError,
      youtube,
      youtubeChannelTitle,
      youtubeCount,
      youtubeLoading,
      youtubeError,
      otherChannels,
      addChannel,
      newChannelName,
      newChannelHandle,
      handles,
      agent,
      agentName,
      agentEmail,
      agentContactNumber,
      associated,
      contentTags,
      brandTags,
      addressLine1,
      city,
      region,
      postalCode,
      description,
      primarySocialHandleYoutube,
      web,
      snapchat,
      linkedin,
      pinterest,

      facebookPageName,
      facebookUserName,
      instagramFullName,
      instagramUserName,
      twitterUserName,
      twitterPageName,
      youtubeChannelUserName,

      facebookVerified,
      twitterVerified,
      instagramVerified,
      youtubeVerified,
      instagramBusinessAccount,
      instagramPrivate,
      isEmailFieldValid,
      isFacebookPersonalPage,

      isLoadingTotals,
      totalInfluencers,

      twitch,
      twitchCount,
      twitchError,
      twitchLoading,
      twitchChannelTitle,


      tiktok,
      tiktokCount,
      tiktokLoading,
      tiktokName,
      tiktokError,
      tiktokVerified,

      telegramUser,
      telegramFound,
      telegramError,
      telegramLoading,

      duplicateInfluencerHandle,
      duplicateInfluencerPlatform,
      duplicateInfluencerLinkId,

      tags,
      businessUnits,
      activeIndex,
      ageGroup,
      gender,
      ethnicity,
    } = this.state;

    const duplicateErrorProps = {
      duplicateInfluencerHandle,
      duplicateInfluencerPlatform,
      duplicateInfluencerLinkId,
    };

    const addInfluencerLinkStyles = {
      color: '#1db08e',
      textWeight: 'bold',
    };

    const sheetIconStyle = {
      marginTop: 20,
      marginBottom: 25,
      color: '#1db08e',
    };

    const shouldDisableSubmitForm = !name ||
    !primarySocialHandle ||
    facebookLoading ||
    instagramLoading ||
    twitterLoading ||
    !isEmailFieldValid ||
    youtubeLoading ||
    telegramLoading;

    const isFullWhiteLabel = ThemeSelector.isFullWhiteLabel();

    if (organisationLoading || isLoadingTotals) {
      return <h1> Loading... </h1>;
    }

    const { licenseInfluencerLimit } = organisation;

    if (totalInfluencers >= licenseInfluencerLimit) {
      return (
        <div className="page">
          <InfluencerContextBar
            rightButtonCallback={this.rightButtonCallback}
            leftButtonCallback={this.leftButtonCallback}
            leftButtonLabel="Create A Campaign"
            rightButtonLabel="Add An Influencer"
            title="Back"
          />
          <div className="page-content">
            <LimitsExceededModal assetType="influencer" />
          </div>
        </div>
      );
    }
    return (
      <div className="page">
        <InfluencerContextBar
          rightButtonCallback={this.rightButtonCallback}
          leftButtonCallback={this.leftButtonCallback}
          leftButtonLabel="Create A Campaign"
          rightButtonLabel="Add An Influencer"
          title="Back"
        />
        <div className="page-content">
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <h2>Add an Influencer</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="10">
                <Segment padded>
                  <h4>Social info</h4>
                  <div className="spacer small" />
                  <Form error onSubmit={this.onSubmit}>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>Facebook<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />
                    <Form.Group widths="equal">
                      <Form.Field error={facebookError}>
                        <NetworkHandleInput
                          network="facebook"
                          error={facebookError}
                          value={facebook}
                          loading={facebookLoading}
                          onChange={this.handleSocialChange}
                          count={facebookCount}
                          isPersonalPage={isFacebookPersonalPage}
                        />
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="facebook" />
                      </Form.Field>

                    </Form.Group>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>Instagram<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />

                    <Form.Group widths="equal">
                      <Form.Field error={instagramError}>
                        <NetworkHandleInput
                          network="instagram"
                          error={instagramError}
                          value={instagram}
                          loading={instagramLoading}
                          onChange={this.handleSocialChange}
                          count={instagramCount}
                        />
                        {
                          _.isEqual(instagramErrorCode, 'ERROR') &&
                          <Label basic color="red" pointing>
                            Sorry… the search failed, <a style={instagramErrorStyle} onClick={this.retryInstagramHandle}>click here</a> to try again!
                          </Label>
                        }
                        {
                          _.isEqual(instagramErrorCode, 'NO_MATCH') &&
                          <Label basic color="red" pointing>
                            Sorry we could not find that username, please check it and try again!
                          </Label>
                        }
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="instagram" />
                      </Form.Field>
                    </Form.Group>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>Twitter<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />

                    <Form.Group widths="equal">
                      <Form.Field error={twitterError}>
                        <NetworkHandleInput
                          network="twitter"
                          error={twitterError}
                          value={twitter}
                          loading={twitterLoading}
                          onChange={this.handleSocialChange}
                          count={twitterCount}
                        />
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="twitter" />
                      </Form.Field>
                    </Form.Group>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>TikTok<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />

                    <Form.Group widths="equal">
                      <Form.Field error={tiktokError}>
                        <NetworkHandleInput
                          network="tiktok"
                          error={tiktokError}
                          value={tiktok}
                          loading={tiktokLoading}
                          onChange={this.handleSocialChange}
                          count={tiktokCount}
                        />
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="tiktok" />
                      </Form.Field>
                    </Form.Group>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>Twitch<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />

                    <Form.Group widths="equal">
                      <Form.Field error={twitchError}>
                        <NetworkHandleInput
                          network="twitch"
                          error={twitchError}
                          value={twitch}
                          loading={twitchLoading}
                          onChange={this.handleSocialChange}
                          count={twitchCount}
                        />
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="twitch" />
                      </Form.Field>
                    </Form.Group>

                    <Popup
                      position="left center"
                      trigger={<span style={blockDisplayStyle}>Telegram<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                      content={HANDLE_PROMPT}
                    />

                    <Form.Group widths="equal">
                      <Form.Field error={telegramError}>
                        <NetworkHandleInput
                          network="telegram"
                          error={telegramError}
                          value={telegramUser}
                          loading={telegramLoading}
                          onChange={this.handleSocialChange}
                          count={telegramFound}
                        />
                        {
                          telegramError &&
                          <Label basic color="red" pointing>
                            We can only accept a valid Telegram user handle (channels and groups are not accepted)
                          </Label>
                        }
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="telegram" />
                      </Form.Field>
                    </Form.Group>

                    <span style={blockDisplayFullWidthStyle}>YouTube -
                      <span style={grey75TextStyle}>
                        Please use Channel ID, Handle, or Username
                      </span>
                      <a href={youtubeHelpUrl} target="blank" >
                        <img style={middleVertAlign} src="/icons/info.svg" alt="info" />
                      </a>
                    </span>

                    <Form.Group widths="equal">
                      <Form.Field error={youtubeError}>
                        <NetworkHandleInput
                          network="youtube"
                          error={youtubeError}
                          value={youtube}
                          loading={youtubeLoading}
                          onChange={this.handleSocialChange}
                          count={youtubeCount}
                        />
                        <DuplicatedInfluencerError {...duplicateErrorProps} platform="youtube" />
                      </Form.Field>
                    </Form.Group>

                    {
                      youtubeChannelTitle
                        ? <Label size="large" color="green" basic>{youtubeChannelTitle}</Label>
                        : <Label size="large" color="grey" basic>{
                          youtubeLoading
                            ? 'loading...'
                            : 'Youtube Channel Title'
                        }</Label>
                    }

                    <Divider />

                    {/* <Form.Input
                      width={12}
                      label={
                        <span><Icon name="pinterest" color="red" />Pinterest
                        </span>}
                      placeholder="Pinterest handle"
                      name="pinterest"
                      onChange={this.handleBasicSocialChange}
                      value={pinterest}
                    />


                    <Form.Input
                      width={12}
                      label={
                        <span><Icon name="snapchat ghost" color="yellow" />Snapchat
                        </span>}
                      placeholder="Snapchat handle"
                      name="snapchat"
                      onChange={this.handleBasicSocialChange}
                      value={snapchat}
                    />


                    <Form.Field
                      width={12}
                    >
                      <span><Icon name="linkedin" color="blue" />LinkedIn</span>
                      <NetworkHandleInput
                        network="linkedin"
                        error={false}
                        value={linkedin}
                        loading={false}
                        onChange={this.handleBasicSocialChange}
                        fluid
                      />
                      <DuplicatedInfluencerError {...duplicateErrorProps} platform="linkedin" />
                    </Form.Field>

                    <Form.Input
                      width={12}
                      label={
                        <span><Icon name="world" color="blue" />Website or Blog
                        </span>}
                      placeholder="Website or Blog"
                      name="web"
                      onChange={this.handleBasicSocialChange}
                      value={web}
                    />

                    <Divider /> */}

                    {/* <p>Add other channels <span className="light">e.g. tumblr, musical.ly</span></p>
                    <div className="spacer small" />
                    { _.map(otherChannels, channel => (
                      <Form.Group key={`${channel.name}-${channel.handle}`}>
                        <Form.Input
                          width={6}
                          name={channel.name}
                          value={channel.name}
                          disabled
                          readOnly
                        />
                        <Form.Input
                          width={6}
                          name={channel.handle}
                          value={channel.handle}
                          disabled
                          readOnly
                        />
                        <Form.Button type="button" width={2} fluid icon="close" onClick={() => this.handleChannelRemove(channel.name, channel.handle)} />
                      </Form.Group>
                    ))}
                    { addChannel &&
                      <Form.Group>
                        <Form.Input
                          width={6}
                          placeholder="Channel name"
                          name="newChannelName"
                          value={newChannelName}
                          onChange={this.handleChange}
                        />
                        <Form.Input
                          width={6}
                          placeholder="Social handle or url"
                          name="newChannelHandle"
                          value={newChannelHandle}
                          onChange={this.handleChange}
                        />
                        <Form.Button type="button" width={2} fluid icon="check" onClick={this.handleChannelAdd} disabled={!newChannelName || !newChannelHandle} />
                        <Form.Button type="button" width={2} fluid icon="close" onClick={() => this.setState({ addChannel: false, newChannelName: '', newChannelHandle: '' })} />
                      </Form.Group>
                    }
                    <Button type="button" onClick={() => this.setState({ addChannel: true })}>Add Channel</Button>
                    <div className="spacer small" /> */}
                    <Form.Dropdown
                      name="primarySocialHandle"
                      label="What are they most known by?"
                      width={12}
                      selection
                      options={handles}
                      onChange={this.handlePrimarySocialHandleChange}
                      placeholder="Select..."
                      required
                      disabled={!facebook && !instagram && !twitterCount && !youtubeCount && !twitchCount && !tiktokCount && !telegramUser}
                    />
                    <div className="spacer small" />
                    <Form.Input
                      width={12}
                      label="Name"
                      placeholder="Influencer&apos;s real name"
                      name="name"
                      onChange={this.handleChange}
                      value={name}
                      required
                    />
                    <div className="spacer small" />
                    <Form.Dropdown
                      search
                      selection
                      width={12}
                      label="Country"
                      value={country}
                      name="country"
                      options={countries}
                      onChange={this.handleChange}
                      required
                    />
                    <Form.Select
                      label="Age"
                      width={12}
                      placeholder="Select age group"
                      name="ageGroup"
                      value={ageGroup}
                      options={ageOptions}
                      onChange={this.handleChange}
                      clearable
                    />
                    <Form.Select
                      label="Gender"
                      width={12}
                      placeholder="Select gender"
                      name="gender"
                      value={gender}
                      options={genderOptions}
                      onChange={this.handleChange}
                      clearable
                    />
                    <Form.Select
                      label="Ethnicity"
                      width={12}
                      placeholder="Select ethnicity"
                      name="ethnicity"
                      value={ethnicity}
                      options={ethnicityOptions}
                      onChange={this.handleChange}
                      clearable
                    />
                    <div className="spacer" />
                    <Divider />
                    <div className="spacer" />

                    <h4>Contact details</h4>
                    <div className="spacer small" />
                    <p>Add the influencer's personal email address,
                      if you plan to invite them to authenticate their social accounts for campaign tracking.
                    </p>
                    <div className="spacer small" />
                    {/* <p>Does your company have an existing association with this influencer?</p>
                    <div className="spacer small" />
                    <Form.Group inline>
                      <Form.Field
                        control={Radio}
                        label="Yes"
                        value="yes"
                        checked={associated}
                        onChange={() => this.setState({ associated: true })}
                      />
                      <Form.Field
                        control={Radio}
                        label="No"
                        value="no"
                        checked={!associated}
                        onChange={() => this.setState({ associated: false })}
                      />
                    </Form.Group> */}
                    <ValidatedEmailField
                      onStateChanged={this.onInfluencerEmailStateChanged}
                    />

                    {/* <Form.Input
                      width={12}
                      label="Contact Number"
                      name="contactNumber"
                      onChange={this.handleChange}
                      value={contactNumber}
                    />
                    <Form.Input
                      width={12}
                      label="Address Line One"
                      name="addressLine1"
                      onChange={this.handleChange}
                      value={addressLine1}
                    />
                    <Form.Input
                      width={12}
                      label="City"
                      name="city"
                      onChange={this.handleChange}
                      value={city}
                    />
                    <Form.Input
                      width={12}
                      label="Region"
                      name="region"
                      onChange={this.handleChange}
                      value={region}
                    />
                    <Form.Input
                      width={12}
                      label="Postal Code"
                      name="postalCode"
                      onChange={this.handleChange}
                      value={postalCode}
                    />
                    <div className="spacer small" />
                    <Form.Group inline>
                      <label>Agent?</label>
                      <Form.Field
                        control={Radio}
                        label="Yes"
                        value="yes"
                        checked={agent}
                        onChange={() => this.setState({ agent: true })}
                      />
                      <Form.Field
                        control={Radio}
                        label="No"
                        value="no"
                        checked={!agent}
                        onChange={() => this.setState({ agent: false })}
                      />
                    </Form.Group>
                    {agent &&
                      <div>
                        <Form.Input
                          width={12}
                          label="Agent's Name"
                          name="agentName"
                          value={agentName}
                          onChange={this.handleChange}
                        />
                        <Form.Input
                          width={12}
                          label="Agent's Email Address"
                          name="agentEmail"
                          value={agentEmail}
                          onChange={this.handleChange}
                        />
                        <Form.Input
                          width={12}
                          label="Agent's Contact Number"
                          name="agentContactNumber"
                          value={agentContactNumber}
                          onChange={this.handleChange}
                        />
                      </div>} */}

                    <div className="spacer" />
                    <Divider />
                    <div className="spacer" />

                    <Accordion>
                      <Accordion.Title
                        active={activeIndex === 0}
                        index={0}
                        onClick={this.toggleOptionalInfo}
                      >
                        { activeIndex !== 0
                          ? <Button floated="right"icon="toggle down" basic content="expand all" onClick={this.toggleCardView} style={buttonStyles} />
                          : <Button floated="right" icon="toggle up" basic content="collapse all" onClick={this.toggleCardView} style={buttonStyles} />
                        }
                      </Accordion.Title>
                      <h4>Optional Information (tags & business units)</h4>
                      <div className="spacer small" />

                      <Accordion.Content active={activeIndex === 0}>
                        <div>Tags</div>
                        <div className="spacer small" />
                        <p>Add tags to your influencer helps you filter your database.
                      To learn how to set-up and manage your global tags <TargetLink href={tagsHelpUrl} renderIf>click here</TargetLink></p>
                        <div className="spacer small" />
                        <TagsSelector
                          selectedTags={tags}
                          onSelected={this.onTagSelected}
                          onUnselected={this.onUnselected}
                        />
                        <div className="spacer small" />
                        <div>Business Units & Brands</div>
                        <div className="spacer small" />
                        <p>Add the business unit or brand that this influencer belongs to.
                      To learn how to add new business units of brands <TargetLink href={businessUnitsHelpUrl} renderIf>click here</TargetLink></p>
                        <div className="spacer small" />
                        <BusinessUnitsSelector
                          selectedBusinessUnits={businessUnits}
                          onSelected={this.onBusinessUnitSelected}
                          onUnselected={this.onUnselectedBusinessUnit}
                        />
                      </Accordion.Content>
                    </Accordion>
                    <div className="spacer small" />
                    <Divider />
                    {/* <Form.Input
                      width={12}
                      label="Content Tags"
                      name="contentTags"
                      placeholder="e.g. football, comedy..."
                      value={contentTags}
                      onChange={this.handleTagChange}
                    />
                    <p>Enter tags, separated by commas.</p>
                    <div className="spacer small" />
                    <Form.Input
                      width={12}
                      label="Brand Tags"
                      name="brandTags"
                      placeholder="e.g. Nike, L'oreal..."
                      value={brandTags}
                      onChange={this.handleTagChange}
                    />
                    <p>Enter tags, separated by commas.</p>
                    <div className="spacer large" />
                    <h4>Description</h4>
                    <div className="spacer small" />
                    <Form.TextArea
                      width={12}
                      name="description"
                      placeholder="Describe this influencer..."
                      value={description}
                      onChange={this.handleChange}
                    /> */}
                    <div className="spacer" />
                    <Form.Button disabled={shouldDisableSubmitForm} width={12} fluid color="pink" size="large">
                Add Influencer
                    </Form.Button>
                  </Form>
                </Segment>
              </Grid.Column>
              <Grid.Column width="6">
                <InfluencerCardPreview
                  primarySocialHandleYoutube={primarySocialHandleYoutube}
                  youtubeChannelTitle={youtubeChannelTitle}
                  name={name}
                  thumbnail={thumbnail}
                  facebookCount={facebookCount}
                  twitterCount={twitterCount}
                  youtubeCount={youtubeCount}
                  instagramCount={instagramCount}
                  tiktokCount={tiktokCount}
                  telegramFound={telegramFound}
                  primarySocialHandle={primarySocialHandle}
                />
                { (youtubeChannelTitle ||
                  instagramUserName ||
                  facebookPageName ||
                  twitch ||
                  tiktok ||
                  twitterUserName ||
                  telegramUser) &&
                  <Table singleLine textAlign="center" verticalAlign="middle">
                    <Table.Header >
                      <Table.Row>
                        <Table.HeaderCell>platform</Table.HeaderCell>
                        <Table.HeaderCell>handle</Table.HeaderCell>
                        <Table.HeaderCell>display name</Table.HeaderCell>
                        <Table.HeaderCell>
                          <Icon name="check circle" color="grey" />
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <SocialChannelInfo
                        isVerified={twitterVerified}
                        username={twitterUserName}
                        fullName={twitterPageName}
                        icon={<TwitterIcon size="large" />}
                      />
                      <SocialChannelInfo
                        isVerified={facebookVerified}
                        username={facebookUserName}
                        fullName={facebookPageName}
                        icon={<FacebookIcon size="large" />}
                      />
                      <SocialChannelInfo
                        isVerified={instagramVerified}
                        username={instagramUserName}
                        fullName={instagramFullName}
                        icon={<InstagramIcon size="large" />}
                        isBusinessAccount={instagramBusinessAccount}
                        isPrivateAccount={instagramPrivate}
                      />
                      <SocialChannelInfo
                        isVerified={youtubeVerified}
                        username={youtubeChannelUserName}
                        fullName={youtubeChannelTitle}
                        icon={<YoutubeIcon size="large" />}
                      />
                      <SocialChannelInfo
                        isVerified={tiktokVerified}
                        username={tiktok}
                        fullName={tiktokName}
                        icon={<TiktokIcon size="large" />}
                      />
                      <SocialChannelInfo
                        isVerified={false}
                        username={twitch}
                        fullName={twitchChannelTitle}
                        icon={<TwitchIcon size="large" />}
                      />
                      <SocialChannelInfo
                        isVerified={false}
                        username={telegramUser}
                        fullName={telegramUser}
                        icon={<TelegramIcon size="large" />}
                      />
                    </Table.Body>
                  </Table>
                }
                {!isFullWhiteLabel && <Segment textAlign="center">
                  <Icon style={sheetIconStyle} name="file excel outline" size="huge" />
                  <div>
                    <p>Already have a spreadsheet of your influencers?</p>
                    <p><a
                      rel="noopener noreferrer"
                      target="_blank"
                      style={addInfluencerLinkStyles}
                      href="https://help.dyzio.co/my-influencers-private-database/import-your-influencers-by-spreadsheet"
                    > Add them to dyzio
                    </a></p>
                  </div>
                </Segment>}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
});

export default hasUserInfo(hasRESTClient(hasOrgansation(connect(mapStateToProps)(InfluencerForm))));



/** WEBPACK FOOTER **
 ** ./src/components/influencer-form/index.js
 **/